export const environment = {
    production: false,
    //baseUrl: 'http://localhost:5000/api/',
    // createdby: 1,
    // EncryptKey: 'z10ds5797a4e4423bbce3ea1024a1817',
    // EncryptIV: 'z10ds5797a4e4423bbce3ea1024a1817',
    baseUrl: 'https://aquapaascentralapi.pozitivehub.com/api/',
    createdby: 1,
    EncryptKey: 'z10ds5797a4e4423bbce3ea1024a1817',
    EncryptIV: 'z10ds5797a4e4423bbce3ea1024a1817',
    authConfig: {
        //authority: "https://localhost:7103/",
        authority: "https://pe-sso-qa.pozitivehub.com/",
        redirectUrl: "https://aquapaascentral.pozitivehub.com/dashboards/customer",
        postLogoutRedirectUri: 'https://aquapaascentral.pozitivehub.com/',
        clientId: "aqua-sso-dev",
        scope: 'openid profile email roles offline_access',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
    },
    // START: Updated Onboarding Configuration
        onboardingConfig: {
          // The relative path for the onboarding page on your central server
          path: 'http://pe-central-sso-qa.pozitivehub.com/onboarding/',
          
          // The Product ID for Aqua (corresponds to LobCd in your central DB)
          // Find this value in your OpenIddictApplications table for ClientId = 'Aqua-SSO'
          productId: '20', // CHANGE THIS to your actual Aqua product ID

          // The full URL that the central app should redirect back to after onboarding.
          // This URL points back to your Aqua application.
          callbackUrl: 'https://aquapaascentral.pozitivehub.com/quotation/add',
          changeCustomerCallbackUrl: 'https://aquapaascentral.pozitivehub.com/CustomerVerification/cotprocess',
          centralapiUrl: 'https://pe-sso-qa.pozitivehub.com/api/'
           // centralapiUrl: 'https://pe-central-sso-staging.pozitivehub.com/api/'

        }
        // END: Updated Onboarding Configuration
};
